import { Box, BoxProps } from 'reflexbox';
import styled, { keyframes } from 'styled-components';
import { rgba } from 'polished';

const rotate = keyframes`
	from { transform: rotateZ(0deg); }
	to { transform: rotateZ(360deg); }
`;

const Container = styled(Box)<{ color?: string }>`
	background: conic-gradient(
		${(props) => rgba(props.theme.colors[props.color ?? 'slateBlue'], props.color ? 0.1 : 0.25)} 25%,
		${(props) => props.theme.colors[props.color ?? 'slateBlue']},
		${(props) => rgba(props.theme.colors[props.color ?? 'slateBlue'], props.color ? 0.1 : 0.25)} 75%
	);
	mask-image: radial-gradient(closest-side, transparent 75%, black 75%, black 100%);
	width: 16px;
	height: 16px;
	box-sizing: border-box;
	border-radius: 8px;

	animation: ${rotate} 2s linear infinite;
`;

export function Spinner(props: BoxProps & { color?: string }) {
	return (
		<Container
			ref={(ref?: HTMLDivElement) =>
				ref?.getAnimations().forEach((animation) => (animation.startTime = 0))
			}
			{...props}
		/>
	);
}
